import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild, WritableSignal, effect,
} from '@angular/core';
import {MapComponent} from "@components/map/map.component";
import {Router, RouterLink} from "@angular/router";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {RegionService} from "@6grain/masofa-monolith-api-client/dictionaries/api/region.service";
import {CropService} from "@6grain/masofa-monolith-api-client/dictionaries/api/crop.service";
import {MessageService} from "primeng/api";
import {BidTypeService} from "@6grain/masofa-monolith-api-client/dictionaries/api/bidType.service";
import {NotReadyApiService} from "@app/api/not-ready-api-service";
import {PrimeNG} from "primeng/config";
import {DateFormatLangPipe} from "@app/utils/pipes/date-format-lang-pipe";
import {MsfSelect} from "@components/select/select";
import {FormsModule} from "@angular/forms";
import {MsfInput} from "@components/ui/forms/input/input";
import {ButtonDirective} from "primeng/button";
import {Divider} from "primeng/divider";
import {DatePipe, NgIf, NgClass} from "@angular/common";
import {CheckboxComponent} from "@components/checkbox";
import {TextareaComponent} from "@components/textarea";
import {GetByIdPipe} from "@app/utils/pipes/get-by-id-pipe";
import {DatePickerComponent} from "@components/date-picker";
import {OpenlayersMapComponent} from "@components/openlayers-map/openlayers-map.component";
import {
  Bid,
  Field,
  FieldService,
  Season,
  SeasonBaseGetQuery,
  SeasonService
} from "@6grain/masofa-monolith-api-client/crop-monitoring";
import {BidService} from "@6grain/masofa-monolith-api-client/crop-monitoring/api/bid.service";
import {BidStateType} from "@6grain/masofa-monolith-api-client/crop-monitoring/model/bidStateType";
import {DialogComponent} from "@components/dialog";
import {EMPTY, Subject, of, from} from "rxjs";
import {catchError, map, switchMap, take, takeUntil, tap} from "rxjs/operators";
import {
  Crop,
  FilterOperator as DictionaryFilterOperator,
  Region,
  RegionMap,
  RegionMapService,
  VarietyService
} from "@6grain/masofa-monolith-api-client/dictionaries";
import {ServerTranslateService} from "@services/server-translate.service";
import {FilterOperator} from "@6grain/masofa-monolith-api-client/crop-monitoring/model/filterOperator";
import {SaveButton} from "@components/button/save-button/save-button/save-button";
import {SecondaryButton} from "@components/button/secondary-button/secondary-button";
import {environment} from '@root/src/environments/environment';
import {userNames} from '@app/utils/_msf';
import {Toast} from 'primeng/toast';
import {Loading} from '@components/ui/loading/loading';
import {IPolygonColor, RequestMapComponent} from '@components/request-map/request-map.component2';
import {
  DetectedFieldsMapLayerDirective
} from '@app/pages/crop-monitoring/components/request-add-page/detected-fields-map-layer.directive';
import {REQUEST_MAP_DEFAULT_POLYGON_COLOR} from '@components/request-map/request-map.colors';
import {ANOMALY_TYPE_COLOR_BY_ENUM} from '@app/pages/crop-monitoring/pages/anomalies/anomaly-type-colors';
import { RequestResultModalComponent } from '../../../request-result-modal/request-result-modal.component';
import { ZipExtractor } from '../../../request-result-modal/utils/zip-extractor.util';
import {MsfSelectPaginated} from '@components/select/paginated/select-paginated';
import {MsfTreeSelect} from '@components/tree-select/tree-select';
import {RegionManagerService} from '@components/openstreetmap/managers/region-manager.service';
import {BID_STATUS_USES, BidStatus} from '@shared/data/bid-status-uses-data';
import {
  areBidPlantingFieldsOptional,
  BID_WORK_TYPE_IDS,
  resolveBidWorkType,
} from '@shared/data/bid-work-type.util';
import {BidWorkTypeService} from '@6grain/masofa-monolith-api-client/dictionaries/api/bidWorkType.service';
import {BidsToSeasonService} from '@services/bids-to-season.service';
import {
  filterSeasonsWithMapPolygon,
  mapSeasonsToSelectOptions,
  seasonHasUsableMapPolygon,
  SeasonSelectOption,
} from '@shared/data/bid-create-from-season.util';
import {PolygonConverterUtil} from '@app/utils/polygon-converter.util';
import {isCoordinateInsidePolygonWkt} from '@app/pages/crop-monitoring/components/request-add-page/survey-point-contour.util';
import {FieldCropsColorPipe} from '@app/utils/pipes/field-crops-color-pipe';
import {FilterOperator as AppFilterOperator} from '@app/utils/filter-operator';
import {
  ParentAnomalySelectOption,
  SatelliteParentAnomalySelectService,
} from '@services/satellite-parent-anomaly-select.service';


export interface BidFormData extends Bid {
  // inspectionStatus?: boolean;
  polygonJson?: any;
  polygon?: string;
  isPublished?: boolean;
  contour?: number;
  taskContent?: string;
  archived?: boolean;
  active?: boolean;
  cancelled?: boolean;
  seedingDate?: string;
  completionDate?: string;
  author?: string;
  flightTarget?: string;
  publish?: boolean;
  archive?: boolean;
  anomalyPolygonId?: string | null;
  bidWorkType?: number;
  seasonId?: string | null;
  /** WT15: zip anomaly_description of the row matching the parent satellite polygon. */
  anomalyComment?: string | null;
}

function readAnomalyComment(value: unknown): string | null {
  if (value == null) {
    return null;
  }
  const text = String(value).trim();
  return text || null;
}

/** Generated Bid type omits anomalyComment; GetById JSON still has it. */
function readBidAnomalyComment(value: unknown): unknown {
  if (!value || typeof value !== 'object') {
    return null;
  }
  const rec = value as Record<string, unknown>;
  return rec['anomalyComment'] ?? rec['AnomalyComment'] ?? null;
}

function normalizeId(value: unknown): string | null {
  if (value == null || value === '') {
    return null;
  }
  const id = String(value).trim();
  return id || null;
}


@Component({
  selector: 'app-ground-survey',
  standalone: true,
  templateUrl: './ground-survey.html',
  styleUrl: './ground-survey.scss',
  providers: [
    TranslatePipe,
    DateFormatLangPipe,
    DatePipe,
    FieldCropsColorPipe,
  ],
  imports: [
    TranslatePipe,
    DateFormatLangPipe,
    MsfSelect,
    FormsModule,
    MsfInput,
    ButtonDirective,
    Divider, NgIf,
    CheckboxComponent,
    TextareaComponent, GetByIdPipe,
    DatePickerComponent,
    DialogComponent,
    NgClass,
    SaveButton, SecondaryButton, Toast, Loading, RequestMapComponent,
    DetectedFieldsMapLayerDirective,
    RequestResultModalComponent, MsfSelectPaginated, MsfTreeSelect,
    RouterLink,
  ]
})
export class GroundSurvey implements OnInit, OnDestroy {
  protected readonly BidStateType = BidStateType;
  private readonly destroy$ = new Subject<void>();
  /** Emits fieldId to load seasons; switchMap cancels prior GetByQuery + crop label fetch. */
  private readonly seasonsFieldId$ = new Subject<string | null>();

  @ViewChild(MapComponent) mapComponent!: MapComponent;
  @ViewChild('groundMap') groundMap!: OpenlayersMapComponent;
  @ViewChild(RequestResultModalComponent) requestResultModal!: RequestResultModalComponent;

  uploadedImage = signal<string | null>(null);
  showPointModal = signal(false);
  isLoadingData = signal(false);
  readonly formValid = signal(false);

  private _pendingSave = false;

  public _bid!: Bid

  showPointModalValue = false;
  pendingMapClick: { lat: number; lng: number } | null = null;
  formData!: BidFormData
  readonly statusOptions: BidStatus[] = [];

  downloading: boolean = false;
  showModalDownload: boolean = false;
  public author!: string | null | undefined;
  public lastUpdateUser!: string;
  public workerName!: string;
  public foremanTouched = false;
  public latTouched = false;
  public lngTouched = false;
  public bidTypeTouched = false;
  public deadlineTouched = false;
  public cropTouched = false;


  isRegion = signal(false);
  isSowingDate = signal(false);
  isCrop = signal(true);
  isField = signal(true);
  isVariety = signal(false);
  today = signal(new Date());
  minDeadline:WritableSignal<any> = signal(null);

  /**
   * Polygons for the request map: field boundary first, optional season planting on top.
   * Bound via [multiPolygonJsonColors].
   */
  mapPolygons = signal<IPolygonColor[]>([]);
  /** When true, lat/lng inputs are disabled (planting selected without map geometry). */
  coordinatesLocked = signal(false);
  /** Controls red centroid pin on the request map. */
  showMapCenterMarker = signal(true);
  /** True while the sowing contour is drawn filled. A map click then places the survey point. */
  readonly surveyPointClickEnabled = signal(false);

  /** Field boundary WKT/GeoJSON retained so we can restore after clearing crop/season. */
  private fieldBoundaryPolygon = '';
  private fieldBoundaryLat: number | null = null;
  private fieldBoundaryLng: number | null = null;
  private cropsById = new Map<string, Crop>();
  /** Avoid toast spam when seasons reload for the same planting without geometry. */
  private missingGeometryToastKey: string | null = null;
  /** Last lat/lng accepted inside the sowing contour. Manual edits revert here. */
  private acceptedSurveyLat: number | null = null;
  private acceptedSurveyLng: number | null = null;
  /** Avoid repeating the click-inside hint for the same planting. */
  private surveyPointClickHintKey: string | null = null;

  private $coordinateChange = new Subject<{ lat: number; lng: number }>();
  private fieldSeasons: Season[] = [];
  seasonOptions: SeasonSelectOption[] = [];
  useSeasonCreate = signal(false);
  /** Edit: season stays visible but locked (CustomUpdate keeps existing SeasonId). */
  isSeasonReadOnly = signal(false);
  bidsToSeasonFlagResolved = signal(false);

  /** Read from formData — two-way select binding can update before modelChange handlers run. */
  isAnomalySurveyWorkType(): boolean {
    return resolveBidWorkType(this.formData?.bidWorkType) === BID_WORK_TYPE_IDS.AnomalySurvey;
  }

  arePlantingFieldsRequired(): boolean {
    return !areBidPlantingFieldsOptional(resolveBidWorkType(this.formData?.bidWorkType));
  }
  seasonTouched = false;
  seasonsLoading = false;
  /** Guards stale GetByQuery responses when field changes quickly (search / re-pick). */
  private seasonsLoadSeq = 0;
  private seasonsLoadedForFieldId: string | null = null;
  private bidsToSeasonEnabled = false;

  varietyFilter: Array<{ filterField: string; filterOperator: any; filterValue: any }> = [];
  showContinueWithoutFiledDialog = false;
  showResultPreview = false;
  showContinueWithoutVarietyDialog: boolean = false
  isVarietyEnabled: boolean = false;

  parentAnomalySelectReload = 0;
  parentAnomalyFieldFilters: Array<{
    filterField: string;
    filterOperator: AppFilterOperator;
    filterValue: unknown;
  }> = [];
  /** WT15 Field select: only fields with active satellite anomalies. */
  readonly anomalySurveyFieldFilters: Array<{
    filterField: string;
    filterOperator: AppFilterOperator;
    filterValue: unknown;
  }> = [
    {
      filterField: 'HasActiveSatelliteAnomalies',
      filterOperator: AppFilterOperator.Equals,
      filterValue: true,
    },
  ];
  /** Apply after seasons reload when parent anomaly sets Field. */
  private pendingSeasonIdFromAnomaly: string | null = null;
  /** Season entity from GetById — seed options if field-scoped list is empty/orphan FieldId. */
  private pendingSeasonEntityFromAnomaly: Season | null = null;
  /** Skip clearing anomalyPolygonId while Field is set from parent anomaly. */
  private applyingParentAnomalyContext = false;
  /** Bump so Field select reloads label after programmatic fieldId. */
  fieldSelectReload = 0;
  /** Avoid re-downloading the result zip for the same FileResultId. */
  private resultZipCommentFileId: string | null = null;
  /** Last parsed result template — apply parent-matching comment after parent option loads. */
  private pendingResultTemplate: unknown | null = null;
  /** Parent satellite WKT for zip anomaly_description match. */
  private parentAnomalyPolygonWkt: string | null = null;

  constructor(
    private router: Router,
    public tr: TranslateService,
    public regionService: RegionService,
    public regionManagerService: RegionManagerService,
    public varietyService: VarietyService,
    public cropService: CropService,
    public fieldService: FieldService,
    public seasonService: SeasonService,
    private bidService: BidService,
    public bidTypeService: BidTypeService,
    public bidWorkTypeService: BidWorkTypeService,
    public notReadyApiService: NotReadyApiService,
    public parentAnomalySelectService: SatelliteParentAnomalySelectService,
    public primeng: PrimeNG,
    private messageService: MessageService,
    private regionMapService: RegionMapService,
    private bidsToSeason: BidsToSeasonService,
    private serverTranslate: ServerTranslateService,
    private fieldCropsColorPipe: FieldCropsColorPipe,
  ) {
    this.resetForm();

    effect(() => {
      let saving: boolean;
      try {
        saving = (this.isSaving as any) ? (this.isSaving as any)() : false;
      } catch (e) {
        saving = false;
      }

      if (!saving && this._pendingSave) {
        this._pendingSave = false;
      }
    });
  }


  @Output() save = new EventEmitter<BidFormData>();
  @Output() cancel = new EventEmitter<void>();
  @Output() bidChange = new EventEmitter<Bid>();

  @Input() isSaving = signal(false);
  @Input() isCanceling = signal(false);

  @Input() set bid(value: Bid) {
    if (value) {
      this._bid = value;
      if (this._bid.id) {
        this.loadMetadata();
        // this.toggleInput();
      }
      this.formData = {
        ...this.formData,
        ...value,
        bidWorkType: resolveBidWorkType((value as BidFormData).bidWorkType),
        polygonJson: value.polygonJson as any,
        publish: parseInt(value.bidState as any)  > BidStateType.NUMBER_0,
        anomalyComment: readAnomalyComment(readBidAnomalyComment(value)),
      };
      if (this.formData.deadlineDate) {
        this.formData.deadlineDate = new Date(this.formData.deadlineDate) as any;
        this.minDeadline.set(this.formData.deadlineDate);
        // this.minDeadline.set(new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate()));
      } else {
        this.minDeadline.set(new Date());
      }
      this.uploadedImage.set(value.fileResultId ? `file://${value.fileResultId}` : null);
      this.loadVarietiesForCrop(this.formData.cropId);
      this.syncSeasonCreateMode();
      this.fillCommentFromResultZip();
      if (this.isAnomalySurveyWorkType()) {
        this.syncParentAnomalyFieldFilters(false);
      }

    } else {
      this.resetForm();
      this.syncSeasonCreateMode();
    }
    this.syncFormValid();
  }

  ngOnInit() {
    this.statusOptions.splice(0, this.statusOptions.length, ...BID_STATUS_USES);
    this.$coordinateChange.subscribe(coords => {
      this.loadFieldByPoints(true, coords.lat, coords.lng);
      this.loadRegionByPoint( coords.lat, coords.lng);
    });
    this.loadTaskType();
    this.bindSeasonFieldLoads();

    if (!this.formData.regionId){
      this.loadRegionByPoint(this.formData.lat as number, this.formData.lng as number);
    }

    this.bidsToSeason.isEnabled().pipe(take(1), takeUntil(this.destroy$)).subscribe((enabled) => {
      this.bidsToSeasonEnabled = enabled;
      this.bidsToSeasonFlagResolved.set(true);
      this.syncSeasonCreateMode();
      this.syncFormValid();
    });
  }

  /**
   * One in-flight season load pipeline: field change cancels prior Season + Crop requests.
   * Applies options only when seq still matches (guards against late emits).
   */
  private bindSeasonFieldLoads(): void {
    this.seasonsFieldId$
      .pipe(
        switchMap((fieldId) => {
          const seq = ++this.seasonsLoadSeq;
          const preserveSeasonId = this.formData.seasonId ?? null;
          if (!fieldId) {
            this.seasonsLoading = false;
            this.clearSeasonSelectionUi();
            return EMPTY;
          }

          this.seasonsLoading = true;
          this.fieldSeasons = [];
          this.seasonOptions = [];
          this.formData.seasonId = null;
          if (this.useSeasonCreate() && !this.isSeasonReadOnly()) {
            this.clearCropUnlessSeasonSelected();
          }

          const query: SeasonBaseGetQuery = {
            filters: [
              {
                filterField: 'fieldId',
                filterOperator: FilterOperator.NUMBER_0,
                filterValue: fieldId,
              },
            ],
          };

          const seasonsSource$ = this.useSeasonCreate()
            ? this.bidService.cropMonitoringBidGetSeasonsForFieldFieldIdGet(fieldId)
            : this.seasonService.cropMonitoringSeasonGetByQueryPost(query);

          return seasonsSource$.pipe(
            switchMap((seasons: Season[]) => {
              let list = filterSeasonsWithMapPolygon(seasons ?? []);
              if (this.isSeasonReadOnly() && preserveSeasonId) {
                const current = (seasons ?? []).find((s) => String(s.id) === String(preserveSeasonId));
                if (current && !list.some((s) => String(s.id) === String(preserveSeasonId))) {
                  list = [...list, current];
                }
              }
              return this.loadCropLabelsForSeasons(list).pipe(
                map((labels) => ({
                  seq,
                  fieldId,
                  seasons: list,
                  labels,
                  ok: true as const,
                  preserveSeasonId,
                })),
              );
            }),
            catchError(() =>
              of({
                seq,
                fieldId,
                seasons: [] as Season[],
                labels: new Map<string, string>(),
                ok: false as const,
                preserveSeasonId,
              }),
            ),
          );
        }),
        takeUntil(this.destroy$),
      )
      .subscribe((result) => {
        if (result.seq !== this.seasonsLoadSeq) {
          return;
        }
        // Prefer requested fieldId; formData may lag banana-binding by one tick.
        if (this.formData.fieldId != null && this.formData.fieldId !== result.fieldId) {
          return;
        }

        this.seasonsLoading = false;
        this.seasonsLoadedForFieldId = result.fieldId;
        this.fieldSeasons = result.seasons;
        this.seasonOptions = mapSeasonsToSelectOptions(
          result.seasons,
          (id) => result.labels.get(id) ?? id,
        );

        if (this.useSeasonCreate()) {
          if (this.tryApplyPendingSeasonFromAnomaly()) {
            return;
          }
          if (!this.formData.seasonId && result.preserveSeasonId) {
            this.formData.seasonId = result.preserveSeasonId;
          }
          if (this.formData.seasonId) {
            const stillValid = this.seasonOptions.some((s) => s.id === this.formData.seasonId);
            if (!stillValid) {
              this.formData.seasonId = null;
              this.clearCropUnlessSeasonSelected();
            } else {
              this.onSeasonChange();
            }
          } else {
            this.clearCropUnlessSeasonSelected();
          }
        }

        this.applyMapGeometryFromSeasonOrField();
      });
  }

  private loadCropLabelsForSeasons(seasons: Season[]) {
    const cropIds = [
      ...new Set(
        seasons
          .map((s) =>
            s.cropId ? String(s.cropId) : s.plannedCropId ? String(s.plannedCropId) : null,
          )
          .filter((id): id is string => !!id),
      ),
    ];

    if (cropIds.length === 0) {
      return of(new Map<string, string>());
    }

    return this.cropService
      .dictionariesCropGetByQueryPost({
        filters: [
          {
            filterField: 'id',
            filterOperator: DictionaryFilterOperator.NUMBER_10,
            filterValue: cropIds,
          },
        ],
      } as any)
      .pipe(
        take(1),
        catchError(() => of([] as Crop[])),
        tap((crops) => {
          for (const crop of crops ?? []) {
            if (!crop?.id) {
              continue;
            }

            this.cropsById.set(String(crop.id), crop);
          }
        }),
        map((crops) => {
          const labels = new Map<string, string>();
          for (const crop of crops ?? []) {
            if (!crop?.id) {
              continue;
            }

            const id = String(crop.id);
            const label = this.serverTranslate.getDisplayValue(crop, 'names');
            if (label) {
              labels.set(id, label);
            }
          }
          return labels;
        }),
      );
  }

  /** Season field when BidsToSeason is on — create and edit. Edit is read-only. */
  private syncSeasonCreateMode(): void {
    const isEdit = !!this._bid?.id;
    this.isSeasonReadOnly.set(isEdit);
    this.useSeasonCreate.set(this.bidsToSeasonEnabled);
    if (this.useSeasonCreate()) {
      if (!isEdit) {
        this.clearCropUnlessSeasonSelected();
      }
      if (this.formData.fieldId) {
        this.loadSeasonsField(this.formData.fieldId);
      }
    }
  }

  private clearCropUnlessSeasonSelected(): void {
    if (!this.formData.seasonId) {
      this.formData.cropId = undefined;
      this.formData.varietyId = undefined;
      this.isVarietyEnabled = false;
      return;
    }

    const selected = this.seasonOptions.find((s) => s.id === this.formData.seasonId);
    if (!selected?.cropId) {
      this.formData.cropId = undefined;
      this.formData.varietyId = undefined;
      this.isVarietyEnabled = false;
    }
  }

  /** Clears season UI state; bumps seq so in-flight apply is ignored. */
  private clearSeasonSelection(): void {
    this.seasonsLoadSeq++;
    this.clearSeasonSelectionUi();
  }

  private clearSeasonSelectionUi(): void {
    this.formData.seasonId = null;
    this.fieldSeasons = [];
    this.seasonOptions = [];
    this.seasonsLoadedForFieldId = null;
    if (this.useSeasonCreate()) {
      this.clearCropUnlessSeasonSelected();
    }
  }

  /**
   * fieldId modelChange (select, clear, search-pick). Uses $event as source of truth —
   * do not re-read formData.fieldId (banana-binding can lag one tick).
   */
  onFieldIdModelChange(fieldId: string | null): void {
    const previous = normalizeId(this.formData.fieldId);
    const next = normalizeId(fieldId);
    this.enabledFieldDeps();
    this.formData.fieldId = fieldId;
    this.loadSeasonsField(fieldId);
    // Re-emit of the already-loaded Field (edit bind) must not drop parent + comment.
    if (
      this.isAnomalySurveyWorkType() &&
      !this.applyingParentAnomalyContext &&
      previous !== next
    ) {
      this.clearParentAnomalyLink();
      this.pendingSeasonIdFromAnomaly = null;
      this.pendingSeasonEntityFromAnomaly = null;
      this.syncParentAnomalyFieldFilters(true);
    }
    this.syncFormValid();
  }

  /**
   * Parent satellite anomaly picked: resolve Season by id (Yer anomalies often have
   * orphan FieldIds not present in crop-monitoring Fields — seasons-by-field is empty).
   * Prefer season.fieldId for the form Field, then Season + Crop.
   */
  onParentAnomalySelected(option: ParentAnomalySelectOption | null): void {
    this.applyParentAnomalyComment(option, true);
    this.syncFormValid();
    if (this._bid?.id) {
      return;
    }

    if (!option?.id) {
      this.pendingSeasonIdFromAnomaly = null;
      this.pendingSeasonEntityFromAnomaly = null;
      return;
    }

    const anomalyFieldId = option.fieldId ? String(option.fieldId) : null;
    const seasonId = option.seasonId ? String(option.seasonId) : null;

    if (seasonId) {
      this.seasonsLoading = true;
      this.seasonService
        .cropMonitoringSeasonGetByIdIdGet(seasonId)
        .pipe(
          takeUntil(this.destroy$),
          catchError(() => of(null as Season | null)),
        )
        .subscribe((season) => {
          this.seasonsLoading = false;
          if (season?.id) {
            this.applyAnomalySeasonContext(season, anomalyFieldId);
            return;
          }
          // Season missing in CM — last resort: anomaly FieldId.
          if (anomalyFieldId) {
            this.applyAnomalyFieldContext(anomalyFieldId, seasonId);
          } else {
            this.pendingSeasonIdFromAnomaly = null;
            this.pendingSeasonEntityFromAnomaly = null;
          }
        });
      return;
    }

    if (anomalyFieldId) {
      this.applyAnomalyFieldContext(anomalyFieldId, null);
    }
  }

  private applyAnomalySeasonContext(season: Season, anomalyFieldId: string | null): void {
    const seasonId = String(season.id);
    const fieldId =
      season.fieldId != null && season.fieldId !== ''
        ? String(season.fieldId)
        : anomalyFieldId;

    if (seasonHasUsableMapPolygon(season)) {
      this.pendingSeasonEntityFromAnomaly = season;
      this.pendingSeasonIdFromAnomaly = seasonId;
    } else {
      this.pendingSeasonEntityFromAnomaly = null;
      this.pendingSeasonIdFromAnomaly = null;
    }

    if (fieldId) {
      const pendingId = seasonHasUsableMapPolygon(season) ? seasonId : null;
      this.applyAnomalyFieldContext(fieldId, pendingId);
      if (pendingId) {
        // Seed immediately so Season/Crop fill even if field season list is empty.
        this.seedSeasonOptionFromEntity(season);
        this.tryApplyPendingSeasonFromAnomaly();
      }
      return;
    }

    this.seedSeasonOptionFromEntity(season);
    this.tryApplyPendingSeasonFromAnomaly();
  }

  private applyAnomalyFieldContext(fieldId: string, seasonId: string | null): void {
    if (seasonId) {
      this.pendingSeasonIdFromAnomaly = seasonId;
    }
    const fieldChanged = String(this.formData.fieldId ?? '') !== fieldId;
    this.applyingParentAnomalyContext = true;
    try {
      this.enabledFieldDeps();
      this.formData.fieldId = fieldId as any;
      this.fieldSelectReload = Date.now();
      this.loadSeasonsField(fieldId);
      this.syncParentAnomalyFieldFilters(false);
    } finally {
      this.applyingParentAnomalyContext = false;
    }
    if (!fieldChanged && this.seasonsLoadedForFieldId === fieldId) {
      this.tryApplyPendingSeasonFromAnomaly();
    }
  }

  private seedSeasonOptionFromEntity(season: Season): void {
    if (!seasonHasUsableMapPolygon(season)) {
      return;
    }
    const id = String(season.id);
    if (!this.fieldSeasons.some((s) => String(s.id) === id)) {
      this.fieldSeasons = [...(this.fieldSeasons ?? []), season];
    }
    if (!this.seasonOptions.some((s) => s.id === id)) {
      const mapped = mapSeasonsToSelectOptions([season]);
      if (mapped[0]) {
        this.seasonOptions = [...this.seasonOptions, mapped[0]];
      }
    }
  }

  private tryApplyPendingSeasonFromAnomaly(): boolean {
    const pending = this.pendingSeasonIdFromAnomaly;
    if (!pending) {
      return false;
    }
    if (this.pendingSeasonEntityFromAnomaly && String(this.pendingSeasonEntityFromAnomaly.id) === pending) {
      if (!seasonHasUsableMapPolygon(this.pendingSeasonEntityFromAnomaly)) {
        return false;
      }
      this.seedSeasonOptionFromEntity(this.pendingSeasonEntityFromAnomaly);
    }
    if (!this.seasonOptions.some((s) => s.id === pending)) {
      return false;
    }
    this.formData.seasonId = pending as any;
    this.pendingSeasonIdFromAnomaly = null;
    this.pendingSeasonEntityFromAnomaly = null;
    this.onSeasonChange();
    return true;
  }

  onBidWorkTypeChange(workType: unknown): void {
    this.formData.bidWorkType = resolveBidWorkType(workType);
    if (!this.isAnomalySurveyWorkType()) {
      this.clearParentAnomalyLink();
      this.parentAnomalyFieldFilters = [];
      this.syncFormValid();
      return;
    }
    this.syncParentAnomalyFieldFilters(true);
    this.syncFormValid();
  }

  /** Field scope for parent satellite anomalies: form field, else selected season.fieldId. */
  private resolveParentAnomalyScopeFieldId(): string | null {
    if (this.formData?.fieldId) {
      return String(this.formData.fieldId);
    }
    const seasonId = this.formData?.seasonId;
    if (!seasonId) {
      return null;
    }
    const season = this.fieldSeasons?.find((s) => s.id === seasonId);
    return season?.fieldId != null && season.fieldId !== ''
      ? String(season.fieldId)
      : null;
  }

  private syncParentAnomalyFieldFilters(reload: boolean): void {
    // Do not FieldId-scope: CustomGet 404s when that field has no Sentinel/Landsat rows.
    // Parent pick still fills Field/Season. Load-by-id already drops FieldId in the service.
    this.parentAnomalyFieldFilters = [];
    if (reload) {
      this.parentAnomalySelectReload = Date.now();
    }
  }

  /** Field picked by the operator: survey point moves to the field center, then to the sowing centroid. */
  onFieldSelected(field: Field | null): void {
    this.applyFieldSelection(field, true);
  }

  /**
   * Field row loaded for an id already on the form (edit / refresh).
   * Keeps Bid.lat / Bid.lng; a later sowing contour still accepts that point when it lies inside.
   */
  onFieldLoaded(field: Field | null): void {
    this.applyFieldSelection(field, false);
  }

  /** Field object side-effects only (region / map / polygon). Seasons follow fieldId via modelChange. */
  private applyFieldSelection(field: Field | null, replaceSurveyPoint: boolean): void {
    if (!field?.id) {
      this.fieldBoundaryPolygon = '';
      this.fieldBoundaryLat = null;
      this.fieldBoundaryLng = null;
      this.clearMapForCropReset();
      this.syncFormValid();
      return;
    }
    this.formData.regionId = field.regionId;
    if (field.centerX && field.centerY) {
      this.fieldBoundaryLat = field.centerY as number;
      this.fieldBoundaryLng = field.centerX as number;
      if (replaceSurveyPoint) {
        this.formData.lat = this.fieldBoundaryLat;
        this.formData.lng = this.fieldBoundaryLng;
      }
    }
    this.onPolygonFieldChange(field);
    this.syncFormValid();
  }

  /** Queue season reload for fieldId ($event or explicit). null clears. */
  loadSeasonsField(fieldId: string | null = this.formData.fieldId ?? null) {
    this.seasonsFieldId$.next(fieldId);
  }


  loadRegionByPoint(lat: number, lng: number) {
    this.regionService.dictionariesRegionGetRegionByPointGet(lng, lat).pipe(takeUntil(this.$coordinateChange), takeUntil(this.destroy$))
      .subscribe(region => {
      this.formData.regionId = region.id;
    })
  }
  loadFieldByPoints(dialogMode = true, lat = this.formData.lat, lng = this.formData.lng) {
    this.isLoadingData.set(true);
    this.fieldService.cropMonitoringFieldGetByPointsGet(lng, lat).pipe(takeUntil(this.$coordinateChange), takeUntil(this.destroy$)).subscribe({
      next: (field: Field) => {
        this.isLoadingData.set(false);
        if (field && field.id) {
          const fieldChanged = this.formData.fieldId !== field.id;
          this.formData.fieldId = field.id;
          if (field.regionId) {
            this.formData.regionId = field.regionId;
          }
          this.formData.regionId = field.regionId;
          if (fieldChanged) {
            this.clearSeasonSelection();
          }
          this.loadSeasonsField(field.id);
          this.isCrop.set(true);
          if (dialogMode) {
            this.showContinueWithoutFiledDialog = false;
          }

        } else {
          if (dialogMode && !this.useSeasonCreate()) {
            this.showContinueWithoutFiledDialog = true;
          }
        }
      },
      error: () => {
        this.isLoadingData.set(false);
        if (dialogMode && !this.useSeasonCreate()) {
          this.showContinueWithoutFiledDialog = true;
        }
      }
    })
  }

  enabledFieldDeps() {
    if (this.formData.fieldId) {
      this.isRegion.set(true);
      this.isCrop.set(true);
      this.isSowingDate.set(true);
      this.isVariety.set(true);
    }

  }


  saveRequest() {
    this.foremanTouched = true;
    this.latTouched = true;
    this.lngTouched = true;
    this.bidTypeTouched = true;
    this.deadlineTouched = true;
    if (this.arePlantingFieldsRequired()) {
      this.cropTouched = true;
      this.seasonTouched = true;
    }

    if (!this.isFormValid()) {
      this.warnIfSurveyPointOutside();
      return;
    }

    const clonedData = {...this.formData};

    this._pendingSave = true;
    try {
      (this.isSaving as unknown as WritableSignal<boolean>).set(true);
    } catch (e) {
    }

    this.bidChange.emit(clonedData);
    this.save.emit(clonedData);
  }

  updateLocalBidState() {
    if (this.formData.bidState !== BidStateType.NUMBER_5) {
      if (this.formData.publish && !this.formData.archive) {
        this.formData.bidState = BidStateType.NUMBER_1;
      } else {
        this.formData.bidState = BidStateType.NUMBER_0;
      }
    }
  }

  onMapClick(coordinate: { lat: number; lng: number }) {
    this.pendingMapClick = {
      lat: coordinate.lat,
      lng: coordinate.lng
    };
    this.showPointModalValue = true;
    this.showPointModal.set(true);
  }

  confirmPointChange() {
    if (this.pendingMapClick) {
      this.formData.lat = this.pendingMapClick.lat;
      this.formData.lng = this.pendingMapClick.lng;
      this.pendingMapClick = null;
      this.$coordinateChange.next({lat: this.formData.lat, lng: this.formData.lng});
    }
    this.showPointModalValue = false;
    this.showPointModal.set(false);
    this.syncFormValid();
  }

  cancelPointChange() {
    this.pendingMapClick = null;
    this.showPointModalValue = false;
    this.showPointModal.set(false);
  }

  onMarkerClick(coordinate: { lat: number; lng: number }) {
    if (!this.usesSowingSurveyPoint()) {
      this.onMapClick(coordinate);
      return;
    }
    if (!this.surveyPointClickEnabled()) {
      return;
    }
    this.placeSurveyPoint(coordinate.lat, coordinate.lng);
  }

  onCoordinatesChange(lat = this.formData.lat, lng = this.formData.lng) {
    if (this.usesSowingSurveyPoint() && this.sowingContourWkt()) {
      this.commitManualSurveyPoint();
      return;
    }
    if (lng && lat) {
      this.$coordinateChange.next({lat, lng});
    }
    this.syncFormValid();
  }

  onPolygonFieldChange(field: Field) {
    this.fieldBoundaryPolygon = field?.polygonJson?.trim() ? String(field.polygonJson) : '';
    this.applyMapGeometryFromSeasonOrField();
  }

  /**
   * Map geometry rules:
   * - field only → field polygon + field center, unless a saved bid already has a point;
   * - planting with geometry → field outline + crop fill; keep a point inside the sowing, otherwise the centroid;
   * - planting without geometry → clear map/coords, lock lat/lng, toast;
   * Does not trigger GetByPoints.
   */
  private applyMapGeometryFromSeasonOrField(): void {
    try {
      this.applyMapGeometryFromSeasonOrFieldCore();
    } finally {
      this.syncSurveyPointTool();
      this.syncFormValid();
    }
  }

  private applyMapGeometryFromSeasonOrFieldCore(): void {
    if (this.seasonsLoading && this.isPlantingSelected()) {
      return;
    }

    const polygons: IPolygonColor[] = [];
    const fieldWkt = this.normalizePolygonToWkt(this.fieldBoundaryPolygon);
    const plantingSelected = this.isPlantingSelected();

    if (!plantingSelected) {
      this.missingGeometryToastKey = null;
      this.coordinatesLocked.set(false);
      if (fieldWkt) {
        polygons.push({
          polygon: fieldWkt,
          color: REQUEST_MAP_DEFAULT_POLYGON_COLOR,
        });
        if (!this.hasSavedSurveyPoint()) {
          this.restoreFieldCenter();
        }
        this.showMapCenterMarker.set(true);
      } else {
        this.showMapCenterMarker.set(this.hasMapPoint());
      }
      this.finishMapPolygons(polygons);
      return;
    }

    const season = this.findSeasonForMapGeometry();
    const seasonPolygonRaw = season?.polygonJson?.trim();
    const seasonWkt = seasonPolygonRaw ? this.normalizePolygonToWkt(seasonPolygonRaw) : '';

    if (!seasonWkt) {
      if (this.seasonsForCurrentFieldStillPending()) {
        return;
      }
      if (this.hasParentAnomalyPolygon()) {
        if (fieldWkt) {
          polygons.push({
            polygon: fieldWkt,
            color: REQUEST_MAP_DEFAULT_POLYGON_COLOR,
            outlineOnly: true,
          });
        }
        this.finishMapPolygons(polygons);
        return;
      }
      this.applyMissingPlantingGeometry();
      return;
    }

    this.missingGeometryToastKey = null;
    this.coordinatesLocked.set(false);
    this.showMapCenterMarker.set(true);

    if (fieldWkt) {
      polygons.push({
        polygon: fieldWkt,
        color: REQUEST_MAP_DEFAULT_POLYGON_COLOR,
        outlineOnly: true,
      });
    }

    polygons.push({
      polygon: seasonWkt,
      color: this.resolveCropPolygonColor(season),
    });
    const coords = PolygonConverterUtil.polygonJsonToCoordinates(seasonPolygonRaw!);
    this.assignSurveyCoordinate(PolygonConverterUtil.getPolygonCenter(coords));
    this.finishMapPolygons(polygons);
  }

  /** Saved Bid.lat/lng must survive the field select hydrating the same field on edit. */
  private hasSavedSurveyPoint(): boolean {
    return !!this._bid?.id && this.hasMapPoint();
  }

  /** Season list for the current field has not arrived yet. Do not treat that as "no sowing polygon". */
  private seasonsForCurrentFieldStillPending(): boolean {
    const fieldId = this.formData.fieldId;
    if (!fieldId || !this.isPlantingSelected()) {
      return false;
    }
    return this.seasonsLoading || this.seasonsLoadedForFieldId !== fieldId;
  }

  private isPlantingSelected(): boolean {
    if (this.useSeasonCreate()) {
      return !!this.formData.seasonId;
    }
    return !!this.formData.cropId;
  }

  /** Crop/season chosen but no usable Season.polygonJson. */
  private applyMissingPlantingGeometry(): void {
    this.mapPolygons.set([]);
    this.clearCoordinates();
    this.coordinatesLocked.set(true);
    this.showMapCenterMarker.set(false);
    this.notifyMissingPlantingGeometry();
  }

  /** Explicit clear of Культура / Сезон: drop polygons, marker, coords. */
  private clearMapForCropReset(): void {
    this.missingGeometryToastKey = null;
    if (this.hasParentAnomalyPolygon()) {
      const polygons: IPolygonColor[] = [];
      const fieldWkt = this.normalizePolygonToWkt(this.fieldBoundaryPolygon);
      if (fieldWkt) {
        polygons.push({
          polygon: fieldWkt,
          color: REQUEST_MAP_DEFAULT_POLYGON_COLOR,
          outlineOnly: true,
        });
      }
      this.finishMapPolygons(polygons);
      this.syncSurveyPointTool();
      return;
    }
    this.mapPolygons.set([]);
    this.clearCoordinates();
    this.coordinatesLocked.set(false);
    this.showMapCenterMarker.set(false);
    this.syncSurveyPointTool();
  }

  private hasParentAnomalyPolygon(): boolean {
    return !!this.normalizePolygonToWkt(this.parentAnomalyPolygonWkt);
  }

  /** Parent satellite polygon on top; marker at its centroid (not field/season). */
  private finishMapPolygons(polygons: IPolygonColor[]): void {
    const wkt = this.normalizePolygonToWkt(this.parentAnomalyPolygonWkt);
    if (wkt) {
      if (polygons.length && !polygons[0].outlineOnly) {
        polygons[0] = {...polygons[0], outlineOnly: true};
      }
      polygons.push({
        polygon: wkt,
        color: ANOMALY_TYPE_COLOR_BY_ENUM[1],
      });
      const coords = PolygonConverterUtil.polygonJsonToCoordinates(wkt);
      this.assignSurveyCoordinate(PolygonConverterUtil.getPolygonCenter(coords));
      this.coordinatesLocked.set(false);
      this.showMapCenterMarker.set(true);
    }
    this.mapPolygons.set(polygons);
  }

  /** Click pin with no field/season polygon. Missing coords keep the marker off. */
  private hasMapPoint(): boolean {
    const lat = Number(this.formData.lat);
    const lng = Number(this.formData.lng);
    return this.formData.lat != null
      && this.formData.lng != null
      && Number.isFinite(lat)
      && Number.isFinite(lng);
  }

  private clearCoordinates(): void {
    this.formData.lat = undefined ;
    this.formData.lng = undefined ;
    this.acceptedSurveyLat = null;
    this.acceptedSurveyLng = null;
  }

  /** Ground survey validates the point against the sowing contour. UAV does not. */
  protected usesSowingSurveyPoint(): boolean {
    return true;
  }

  private sowingContourWkt(): string {
    if (!this.usesSowingSurveyPoint() || !this.isPlantingSelected()) {
      return '';
    }
    return this.normalizePolygonToWkt(this.findSeasonForMapGeometry()?.polygonJson);
  }

  private isSurveyPointInside(lat: unknown, lng: unknown, wkt: string): boolean {
    return isCoordinateInsidePolygonWkt(Number(lat), Number(lng), wkt);
  }

  /**
   * Keep a point already inside the sowing contour. Otherwise use `candidate`
   * when it falls inside. With no sowing contour, write `candidate` as before.
   */
  private assignSurveyCoordinate(candidate: { lat: number; lng: number } | null): void {
    const wkt = this.sowingContourWkt();
    if (!wkt) {
      if (candidate) {
        this.formData.lat = candidate.lat;
        this.formData.lng = candidate.lng;
      }
      return;
    }

    if (this.isSurveyPointInside(this.formData.lat, this.formData.lng, wkt)) {
      this.rememberAcceptedSurveyPoint();
      return;
    }

    if (candidate && this.isSurveyPointInside(candidate.lat, candidate.lng, wkt)) {
      this.formData.lat = candidate.lat;
      this.formData.lng = candidate.lng;
      this.rememberAcceptedSurveyPoint();
      this.surveyPointClickHintKey = null;
      return;
    }

    this.clearCoordinates();
    this.showMapCenterMarker.set(false);
    this.notifySurveyPointMustBePlaced();
  }

  private placeSurveyPoint(lat: number, lng: number): void {
    const wkt = this.sowingContourWkt();
    if (!wkt) {
      return;
    }
    if (!this.isSurveyPointInside(lat, lng, wkt)) {
      this.warnSurveyPoint('SURVEY_POINT_OUTSIDE_CONTOUR');
      return;
    }

    this.formData.lat = lat;
    this.formData.lng = lng;
    this.rememberAcceptedSurveyPoint();
    this.showMapCenterMarker.set(true);
    this.groundMap?.updateCenterMarker(lng, lat);
    this.syncFormValid();
  }

  private commitManualSurveyPoint(): void {
    const wkt = this.sowingContourWkt();
    const lat = Number(this.formData.lat);
    const lng = Number(this.formData.lng);
    if (!this.isSurveyPointInside(lat, lng, wkt)) {
      this.formData.lat = this.acceptedSurveyLat ?? undefined;
      this.formData.lng = this.acceptedSurveyLng ?? undefined;
      this.warnSurveyPoint('SURVEY_POINT_OUTSIDE_CONTOUR');
      if (this.acceptedSurveyLat != null && this.acceptedSurveyLng != null) {
        this.groundMap?.updateCenterMarker(this.acceptedSurveyLng, this.acceptedSurveyLat);
      }
      this.syncFormValid();
      return;
    }

    this.rememberAcceptedSurveyPoint();
    this.showMapCenterMarker.set(true);
    this.groundMap?.updateCenterMarker(lng, lat);
    this.syncFormValid();
  }

  private rememberAcceptedSurveyPoint(): void {
    const lat = Number(this.formData.lat);
    const lng = Number(this.formData.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }
    this.acceptedSurveyLat = lat;
    this.acceptedSurveyLng = lng;
  }

  private syncSurveyPointTool(): void {
    const wkt = this.sowingContourWkt();
    const enabled = !!wkt && this.mapPolygons().some((item) => item.polygon === wkt && !item.outlineOnly);
    this.surveyPointClickEnabled.set(enabled);
    if (!enabled) {
      this.surveyPointClickHintKey = null;
    }
  }

  private notifySurveyPointMustBePlaced(): void {
    const key = this.useSeasonCreate()
      ? `season:${this.formData.seasonId ?? ''}`
      : `crop:${this.formData.cropId ?? ''}`;
    if (!key.endsWith(':') && this.surveyPointClickHintKey === key) {
      return;
    }
    this.surveyPointClickHintKey = key;
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'SURVEY_POINT_CLICK_INSIDE',
      life: 5000,
    });
  }

  private warnIfSurveyPointOutside(): void {
    const wkt = this.sowingContourWkt();
    if (!wkt || !this.hasMapPoint()) {
      return;
    }
    if (!this.isSurveyPointInside(this.formData.lat, this.formData.lng, wkt)) {
      this.warnSurveyPoint('SURVEY_POINT_OUTSIDE_CONTOUR');
    }
  }

  private warnSurveyPoint(detail: string): void {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail,
      life: 5000,
    });
  }

  private restoreFieldCenter(): void {
    if (this.fieldBoundaryLat != null && this.fieldBoundaryLng != null) {
      this.formData.lat = this.fieldBoundaryLat;
      this.formData.lng = this.fieldBoundaryLng;
    }
  }

  private notifyMissingPlantingGeometry(): void {
    const key = this.useSeasonCreate()
      ? `season:${this.formData.seasonId ?? ''}`
      : `crop:${this.formData.cropId ?? ''}`;
    if (!key.endsWith(':') && this.missingGeometryToastKey === key) {
      return;
    }
    this.missingGeometryToastKey = key;
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'SEASON_NO_MAP_BOUNDARIES',
      life: 5000,
    });
  }

  private findSeasonForMapGeometry(): Season | null {
    if (this.useSeasonCreate() && this.formData.seasonId) {
      return this.fieldSeasons.find((s) => s.id === this.formData.seasonId) ?? null;
    }

    const cropId = this.formData.cropId ? String(this.formData.cropId) : null;
    if (!cropId) {
      return null;
    }

    const matches = this.fieldSeasons.filter(
      (s) =>
        (s.cropId != null && String(s.cropId) === cropId) ||
        (s.plannedCropId != null && String(s.plannedCropId) === cropId),
    );
    return matches.find((s) => seasonHasUsableMapPolygon(s)) ?? null;
  }

  private normalizePolygonToWkt(polygonJson: string | null | undefined): string {
    if (!polygonJson?.trim()) {
      return '';
    }
    const trimmed = polygonJson.trim();
    if (trimmed.toUpperCase().startsWith('POLYGON')) {
      return trimmed;
    }
    const coords = PolygonConverterUtil.polygonJsonToCoordinates(trimmed);
    if (coords.length < 3) {
      return '';
    }
    return PolygonConverterUtil.coordinatesLatLonToWKT(coords);
  }

  private resolveCropPolygonColor(season: Season | null): string {
    const cropId = season?.cropId
      ? String(season.cropId)
      : season?.plannedCropId
        ? String(season.plannedCropId)
        : this.formData.cropId
          ? String(this.formData.cropId)
          : null;
    const crop = cropId ? this.cropsById.get(cropId) : null;
    if (crop) {
      return this.fieldCropsColorPipe.transform(crop, 0.44);
    }
    return REQUEST_MAP_DEFAULT_POLYGON_COLOR;
  }
  
  loadRegionMap(id:string) {
    this.isLoadingData.set(true);
    this.regionMapService.dictionariesRegionMapGetByIdIdGet(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (regionMap: RegionMap) => {
        this.isLoadingData.set(false);
        this.formData.lat = regionMap.lat as number;
        this.formData.lng = regionMap.lng as number;
        this.$coordinateChange.next({lat: this.formData.lat, lng: this.formData.lng});
      },
      error: () => {
      }
    })
  }


  onRegionChange(region:Region) {
    if (region) {
      const regionMapId = region.regionMapId;
      this.loadRegionMap(regionMapId as string)
    }
  }


  loadMetadata() {
    const bidId = this._bid.id;
    if (!bidId) {
      return;
    }

    this.bidService.cropMonitoringBidCustomGetByIdIdGet(bidId).pipe(
      takeUntil(this.destroy$),
    ).subscribe({
      next: (detail) => {
        this.author = userNames(detail.createUser);
        this.lastUpdateUser = userNames(detail.lastUpdateUser);
        this.workerName = userNames(detail.worker);
      },
    });
  }


  removeImage(event?: Event) {
    event?.stopPropagation();
    this.uploadedImage.set(null);
  }


  resetForm(): void {
    this.formData = {
      id: undefined,
      createAt: undefined,
      lastUpdateAt: undefined,
      foremanId: null,
      bidState: BidStateType.NUMBER_0,
      // bidTypeId: BID_STATUS.New,
      description: '',
      comment: '',
      deadlineDate: undefined,
      regionId: null,
      cropId: undefined,
      customer: null,
      active: true,
      cancelled: false,
      publish: false,
      bidWorkType: BID_WORK_TYPE_IDS.Default,
      seasonId: null,
      anomalyPolygonId: null,
      anomalyComment: null,
      lat: environment.map.lat,
      lng: environment.map.lng,
    };
    
    this.pendingResultTemplate = null;
    this.parentAnomalyPolygonWkt = null;
    this.resultZipCommentFileId = null;
    this.varietyFilter = [];


    // Reset uploaded image
    this.removeImage()
    this.syncFormValid();
  }


  /** Finished bids: Bid.Comment is empty until SaveResult maps GeneralData.comment. */
  private fillCommentFromResultZip(): void {
    const fileId = this.formData.fileResultId as string | undefined;
    const needGeneral = !readAnomalyComment(this.formData.comment);
    const needAnomaly = this.isAnomalySurveyWorkType() && !readAnomalyComment(this.formData.anomalyComment);
    if (!fileId || (!needGeneral && !needAnomaly)) {
      return;
    }
    if (this.resultZipCommentFileId === fileId) {
      return;
    }
    this.resultZipCommentFileId = fileId;
    this.notReadyApiService.downloadFile(fileId).pipe(
      switchMap((blob) => from(ZipExtractor.loadTemplateJson(blob))),
      takeUntil(this.destroy$),
    ).subscribe({
      next: (template) => {
        this.pendingResultTemplate = template;
        const generalComment = template ? ZipExtractor.parseGeneralDataComment(template) : null;
        const anomalyComment = this.anomalyCommentFromPendingZip();
        const next: BidFormData = {...this.formData};
        if (generalComment && !readAnomalyComment(next.comment)) {
          next.comment = generalComment;
        }
        if (anomalyComment && !readAnomalyComment(next.anomalyComment)) {
          next.anomalyComment = anomalyComment;
        }
        this.formData = next;
      },
      error: () => {
        this.resultZipCommentFileId = null;
        this.pendingResultTemplate = null;
      },
    });
  }

  onParentAnomalyOptionLoaded(option: ParentAnomalySelectOption | null): void {
    // Edit load: Bid.anomalyComment is the survey comment. Satellite polygon
    // comment is a different field and is often empty after SaveResult (Hidden).
    if (this._bid?.id) {
      if (option?.id) {
        this.parentAnomalyPolygonWkt = readAnomalyComment(option.polygonJson);
        if (!readAnomalyComment(this.formData.anomalyComment)) {
          const fromZip = this.anomalyCommentFromPendingZip();
          if (fromZip) {
            this.formData = {...this.formData, anomalyComment: fromZip};
          }
        }
        this.applyMapGeometryFromSeasonOrField();
      }
      return;
    }
    this.applyParentAnomalyComment(option, false);
  }

  private clearParentAnomalyLink(): void {
    this.formData.anomalyPolygonId = null;
    this.formData.anomalyComment = null;
    this.parentAnomalyPolygonWkt = null;
    this.applyMapGeometryFromSeasonOrField();
  }

  private applyParentAnomalyComment(
    option: ParentAnomalySelectOption | null,
    overwrite: boolean,
  ): void {
    if (!option?.id) {
      if (overwrite) {
        this.formData.anomalyComment = null;
        this.parentAnomalyPolygonWkt = null;
        this.applyMapGeometryFromSeasonOrField();
      }
      return;
    }

    this.parentAnomalyPolygonWkt = readAnomalyComment(option.polygonJson);
    this.applyMapGeometryFromSeasonOrField();
    const fromOption = readAnomalyComment(option.comment);
    const current = readAnomalyComment(this.formData.anomalyComment);
    if (fromOption && (overwrite || !current)) {
      this.formData.anomalyComment = fromOption;
      return;
    }
    if (!overwrite && current) {
      return;
    }
    const fromZip = this.anomalyCommentFromPendingZip();
    if (fromZip) {
      this.formData.anomalyComment = fromZip;
    }
  }

  private anomalyCommentFromPendingZip(): string | null {
    if (!this.pendingResultTemplate) {
      return null;
    }
    return ZipExtractor.parseParentMatchingAnomalyDescription(
      this.pendingResultTemplate,
      this.parentAnomalyPolygonWkt,
    );
  }

  downloadBidFile() {
    const fileId = this.formData.fileResultId as string;

    if (!fileId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No file',
        detail: 'No result file attached to this request',
        life: 3000
      });
      return;
    }

    // Open the RequestResultModalComponent which will handle downloading and showing the contents
    if (this.requestResultModal && typeof this.requestResultModal.open === 'function') {
      this.requestResultModal.open(fileId);
    } else {
      // Fallback: show error to user
      console.warn('RequestResultModalComponent not available to open file result');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unable to open result modal',
        life: 3000
      });
    }
  }


  notContinueWithoutField() {
    this.showContinueWithoutFiledDialog = false;
    this.router.navigate(['/crop-monitoring/requests/add']);
  }

  anomalyPolygonLinkId(): string | null {
    const raw =
      this.formData?.anomalyPolygonId ??
      (this._bid as {anomalyPolygonId?: string | null})?.anomalyPolygonId;
    if (raw == null || raw === '') {
      return null;
    }
    return String(raw);
  }

  isFormValid(): boolean {
    const valid = this.computeFormValid();
    this.formValid.set(valid);
    return valid;
  }

  private computeFormValid(): boolean {
    const base = !!(
      this.formData.lat &&
      this.formData.lng &&
      this.formData.deadlineDate &&
      this.formData.foremanId
    );
    if (!base) {
      return false;
    }
    const sowingWkt = this.sowingContourWkt();
    if (sowingWkt && !this.isSurveyPointInside(this.formData.lat, this.formData.lng, sowingWkt)) {
      return false;
    }
    // WT15: parent anomaly + base only; Field/Season/Crop optional (auto-fill when available).
    if (this.isAnomalySurveyWorkType()) {
      return !!this.formData.anomalyPolygonId;
    }
    // WT10: culture, season, sowing date, variety optional.
    if (!this.arePlantingFieldsRequired()) {
      return true;
    }
    if (this.useSeasonCreate()) {
      return !!this.formData.seasonId && !!this.formData.cropId;
    }
    return !!this.formData.cropId;
  }

  private syncFormValid(): void {
    this.formValid.set(this.computeFormValid());
  }

  onRequiredFieldChange(): void {
    this.syncFormValid();
  }

  onSeasonChange(season?: SeasonSelectOption | null) {
    this.formData.varietyId = undefined;

    const selected =
      season ??
      this.seasonOptions.find((s) => s.id === this.formData.seasonId) ??
      null;
      
    if (!selected) {
      this.formData.cropId = undefined;
      this.clearMapForCropReset();
      if (this.isAnomalySurveyWorkType()) {
        this.syncParentAnomalyFieldFilters(true);
      }
      this.syncFormValid();
      return;
    }

    if (selected.cropId) {
      this.formData.cropId = selected.cropId as any;
      this.loadVarietiesForCrop(selected.cropId);
    } else {
      this.formData.cropId = undefined;
    }

    if (selected.plantingDate && !this.formData.fieldPlantingDate) {
      this.formData.fieldPlantingDate = new Date(selected.plantingDate).toISOString();
    }

    this.applyMapGeometryFromSeasonOrField();
    const scopeBefore = this.resolveParentAnomalyScopeFieldId();

    // Prefer season.fieldId when form field is empty (BidsToSeason create).
    const seasonEntity = this.fieldSeasons?.find((s) => s.id === selected.id);
    if (!this.formData.fieldId && seasonEntity?.fieldId) {
      this.formData.fieldId = String(seasonEntity.fieldId) as any;
    }
    
    if (this.isAnomalySurveyWorkType()) {
      const scopeAfter = this.resolveParentAnomalyScopeFieldId();
      if (scopeBefore !== scopeAfter) {
        this.clearParentAnomalyLink();
      }
      this.syncParentAnomalyFieldFilters(true);
    }
    this.syncFormValid();
  }

  continueWithoutField() {
    if (this.useSeasonCreate()) {
      this.showContinueWithoutFiledDialog = false;
      return;
    }

    this.isCrop.set(true);
    this.isRegion.set(true);
    this.isSowingDate.set(true);
    this.isVariety.set(true);
    this.isField.set(false);
    this.showContinueWithoutFiledDialog = false;
    this.showContinueWithoutVarietyDialog = false;
    // Reset the field according to the context (update or creation)
    if (this.formData.fieldId) {
      if (this._bid && this._bid.fieldId) {
        this.formData.fieldId = this._bid.fieldId;
      } else {
        this.formData.fieldId = null;
      }
    }
  }

  onCropChange() {
    const foundedCropSeason = this.fieldSeasons?.find(
      (season) => season.cropId === this.formData.cropId && seasonHasUsableMapPolygon(season),
    );
    this.formData.varietyId = undefined;
    this.loadVarietiesForCrop(this.formData.cropId);

    if (!this.formData.cropId) {
      this.isVarietyEnabled = false;
      this.clearMapForCropReset();
      this.syncFormValid();
      return;
    }

    if (foundedCropSeason) {
      if (!this.formData.fieldPlantingDate){
        this.formData.fieldPlantingDate = new Date(foundedCropSeason.startDate as string).toISOString();
      }
    } else {
      if (!this.formData.fieldPlantingDate){
        this.formData.fieldPlantingDate = undefined;
      }
      this.showContinueWithoutVarietyDialog = false;
    }
    this.isVarietyEnabled = !!this.formData.cropId;
    this.applyMapGeometryFromSeasonOrField();
    this.syncFormValid();
  }

  private loadVarietiesForCrop(cropId?: string | null) {
    this.isVarietyEnabled = !!cropId;

    if (!cropId) {
      this.formData.varietyId = undefined;
      this.varietyFilter = [];
      return;
    }

    // The paginated variety select fetches pages itself using this filter.
    // VarietyService is a dictionaries API — use the dictionaries FilterOperator
    // (Equals), not the crop-monitoring one.
    this.varietyFilter = [
      {
        filterField: 'CropId',
        filterOperator: DictionaryFilterOperator.NUMBER_0,
        filterValue: cropId,
      },
    ];
  }

  onDialogShow(): void {
    setTimeout(() => {
      if (this.groundMap) {
        //@ts-ignore
        this.groundMap.updateCenterMarker(this.formData.lat, this.formData.lng);
// Ensure the map resizes properly
      }
    }, 0);
  }

  isFutureDate(date: string | Date | null | undefined): boolean {
    if (!date) return false;

    const parsed = typeof date === 'string' ? new Date(date) : date;
    return parsed > this.today();
  }

  loadTaskType() {
    this.bidTypeService.dictionariesBidTypeGetByQueryPost({}).subscribe({
      next: (bidTypes) => {
        if (bidTypes.length > 0){
          this.formData.bidTypeId = bidTypes[0]?.id;

        }
      },
      error: (error) => {
        console.error('Error loading bid types:', error);
      }
    })
  }

  regionChanged() {

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
